export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved



// WEBPACK FOOTER //
// ./src/store/modules/address/show/getters.js